// In a new file: src/utils/apiUtils.js
export const retryRequest = async (requestFn, maxRetries = 3, delay = 1000) => {
  let lastError;
  
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await requestFn();
    } catch (error) {
      console.log(`Attempt ${attempt + 1} failed. Retrying...`);
      lastError = error;
      
      // Only retry for network-related errors, not server errors
      if (error.response) {
        throw error; // Don't retry if server returned an error response
      }
      
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  
  throw lastError; // All retries failed
};